import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";

const IntegrationLayout = ({ tabConfig, defaultTab = "", title = "" }) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);

  const renderTabContent = () => {
    const current = tabConfig.find((tab) => tab.value === currentTab);
    return current?.component || null;
  };

  return (
    <Box sx={{ display: "flex", height: "100vh"}}>
      {/* Left Panel */}
      {/* <Box sx={{ width: 400, borderRight: "1px solid #ccc", p: 2, backgroundColor: "#f5f5f5"  }}>
        {leftPanel}
      </Box> */}

      {/* Right Panel */}
      <Box sx={{ flexGrow: 1, p: 2 }}>
{/*         {title && <h2>{title}</h2>} */}

        <Tabs
          value={currentTab}
          onChange={(e, val) => setCurrentTab(val)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabConfig.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>

        <Box mt={2}>{renderTabContent()}</Box>
      </Box>
    </Box>
  );
};

export default IntegrationLayout;
